export const SLIDE_SWITCHING_DELAY = 5000;
export const SLIDE_APPEARING_TIME = 200;

export const IMAGES_NAMES = {
    BEAUTY: 'beauty',
    PIZZERIA: 'pizzeria',
    REAL_ESTATE: 'real-estate',
};
